export const removeCharAt = (str: string, i: number): string => {
  const tmp = str.split("")
  tmp.splice(i, 1)
  return tmp.join("")
}

export const removeBOM = (str: string): string => {
  return str.replace(/^\uFEFF/gm, "").replace(/^\u00EF?\u00BB\u00BF/gm, "")
}
